import './App.css'
import './i18n'
import About from './components/About/About'
import Benefits from './components/Benefits/Benefits'
import Header from './components/Header/Header'
import Hero from './components/Hero/Hero'
import Slider from './components/Slider/Slider'
import Studies from './components/Studies/Studies'
import Pricing from './components/Pricing/Pricing'
import Why from './components/Why/Why'
import Footer from './components/Footer/Footer'

function App() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Studies />
      <Benefits />
      <Slider />
      <Pricing />
      <Why />
      <Footer />
    </>
  )
}

export default App
